import { z } from 'zod';
import { objectIdStr } from './common.js';

export const component = z.object({
  code: z.string().min(1),
  name: z.string().optional(),
  qrText: z.string().min(1),
});
export type Component = z.infer<typeof component>;

export const part = z.object({
  _id: objectIdStr,
  jobId: objectIdStr,
  batchId: objectIdStr,
  /** Part code, unique across the whole job (e.g. `R1C13`) — batches do not namespace it. */
  code: z.string().min(1),
  name: z.string().optional(),
  width: z.string().optional(),
  height: z.string().optional(),
  depth: z.string().optional(),
  finished: z.string().optional(),
  /**
   * Marks the parts that actually carry a printed QR label. Most parts do not —
   * labelling is opt-in (SPEC §2), so coverage must always be reported honestly.
   */
  tracked: z.boolean().default(false),
  qrText: z.string().min(1),
  components: z.array(component).default([]),
  createdAt: z.coerce.date(),
});
export type Part = z.infer<typeof part>;

export const partCreate = z.object({
  code: z.string().min(1),
  name: z.string().optional(),
  width: z.string().optional(),
  height: z.string().optional(),
  depth: z.string().optional(),
  finished: z.string().optional(),
  tracked: z.boolean().optional(),
  /** Only used to reproduce a legacy QR text; defaults to today in the shop timezone. */
  createdOn: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
});
export type PartCreate = z.infer<typeof partCreate>;

export const partPatch = z.object({
  name: z.string().optional(),
  width: z.string().optional(),
  height: z.string().optional(),
  depth: z.string().optional(),
  finished: z.string().optional(),
  tracked: z.boolean().optional(),
});
export type PartPatch = z.infer<typeof partPatch>;

export const componentCreate = z.object({
  name: z.string().min(1),
});
export type ComponentCreate = z.infer<typeof componentCreate>;
